import { DecimalPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';
import { VideoTimeData } from '../../../gallery-shared/components/video-viewer/video-viewer.component';
import { sleep } from '../../../lib/sleep';
import { StateService } from '../../../services/state.service';
import { VideoTimeService } from '../../../services/video-time.service';
import { SvgComponent } from '../../../shared/components/svg/svg.component';
import { ButtonDirective } from '../../../shared/directives/button.directive';
import { TooltipDirective } from '../../../shared/directives/tooltip.directive';
import { FloorPipe } from '../../../shared/pipes/floor.pipe';

@Component({
  selector: 'app-video-viewer-controls',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './video-viewer-controls.component.html',
  styleUrls: ['./video-viewer-controls.component.scss'],
  imports: [FloorPipe, SvgComponent, ButtonDirective, TooltipDirective, DecimalPipe],
})
export class VideoViewerControlsComponent {
  @Input({ required: true }) time: VideoTimeData;
  public state = inject(StateService);
  public videoTime = inject(VideoTimeService);
  mouseIsDown = false;

  toggleMode() {
    this.state.videoSettings.timeMode = this.state.videoSettings.timeMode === 'seconds' ? 'frames' : 'seconds';
  }

  mouseDown(direction: number) {
    this.mouseIsDown = true;
    this.timeChange(direction);
  }

  mouseUp() {
    this.mouseIsDown = false;
  }

  async timeChange(movement: number, delay = 250) {
    if (!this.mouseIsDown) return;
    this.videoTime.changeFrame(Math.floor(movement));
    await sleep(Math.max(delay, 20));
    this.timeChange(movement, delay * 0.9);
  }
}
